export function createDebounce(func: (...args) => void, delay: number) {
  let timer;

  return (...args) => {
    clearTimeout(timer);

    const promise = new Promise((resolve) => {
      timer = setTimeout(() => {
        resolve(func(...args));
      }, delay);
    });

    return promise;
  };
}
